import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'xp-modal',
  template: `
    <div cdkOverlayOrigin #trigger="cdkOverlayOrigin"></div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOverlayOpen">
      <div class="fade modal-backdrop" (click)="closeModal()" [ngClass]="{ in: addInClass }"></div>
      <div class="modal fade new-dialog" [ngClass]="{ in: addInClass }" style="display: block;">
        <div class="modal-dialog" [ngClass]="isSmall ? 'thin' : 'modal-lg'">
          <div *ngIf="!isBack" class="modal-btn-close" (click)="closeModal()">
            <span>{{ closeButtonText }}</span>
          </div>
          <div *ngIf="isBack" class="modal-btn-back new" (click)="closeModal()">
            <span>{{ closeButtonText }}</span>
          </div>
          <div class="modal-body no-padding">
            <ng-template [ngTemplateOutlet]="modalBody"></ng-template>
          </div>
        </div>
      </div>
    </ng-template>
  `,
})
export class XpModalComponent implements OnChanges {
  @Input() closeButtonText = 'Close';
  @Input() titleText = '';
  @Input() descriptionText = '';
  @Input() saveButtonText = 'Save changes';
  @Input() isOpen = false;
  @Input() isSmall = false;
  @Input() isBack = false;
  @Output() close = new EventEmitter();
  @ContentChild(TemplateRef) modalBody: TemplateRef<any>;

  addInClass = false;
  isOverlayOpen = false;

  ngOnChanges(changes: SimpleChanges) {
    const { isOpen } = changes;
    if (isOpen && isOpen.currentValue && !isOpen.previousValue) {
      this.isOverlayOpen = true;
      setTimeout(() => {
        this.addInClass = true;
      }, 200);
    }

    if (isOpen && !isOpen.currentValue && isOpen.previousValue) {
      this.addInClass = false;
      setTimeout(() => {
        this.isOverlayOpen = false;
      }, 200);
    }
  }

  closeModal() {
    this.close.emit();
  }
}
